import { Config, CONFIG } from "src/app/_models/config";
import { DOCUMENT } from "@angular/common";
import { Component, HostListener, OnInit, ViewChild, ElementRef, Inject, Output, EventEmitter, OnDestroy } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { delay } from "rxjs/operators";
import { ObjectLiteral } from "src/app/_models/user";
import { ENVIRONMENT, FLIGHT_LOOKUP_FORM, PARAMS, PAYMENT_NOTIFICATION_MESSAGE, ROUTING_CODES, STORAGE_KEYS, supportedOS } from "src/app/_constants/app.constants";
import { SessionUtilityService } from "src/app/_services/session/session/session-utility/session-utility.service";
import { Subscription } from "rxjs";
import { HelpOptionsService } from "src/app/_services/api/help-options/help-options.service";
import { RtcService } from "src/app/_services/sdk/rtc/rtc.service";
import { FlightService } from 'src/app/_services/api/flight/flight.service';
import { LanguageService } from 'src/app/_services/api/language/language.service';
import { LoggerService } from 'src/app/_services/ui/logger/logger.service';
import { LoadingService } from 'src/app/_services/ui/loading/loading.service';
import { SessionService } from 'src/app/_services/session/session.service'; 
import { SESSION_STORAGE_SERVICE } from 'src/app/_services/session/session.service'; 
import { StorageService } from 'ngx-webstorage-service';
import { WelcomeService } from "../_services/welcome.service";

@Component({
  selector: "ua-flight-lookup-form",
  templateUrl: "./flight-lookup-form.component.html",
  styleUrls: ["./flight-lookup-form.component.scss"],
})
export class FlightLookupFormComponent implements OnInit, OnDestroy {

  @HostListener('document:click', ['$event']) onWindowClick(): void {
    this.isTooltipDisplayed = false;
  }

  @Output() errorMessageEmitter = new EventEmitter<string>();

  title = FLIGHT_LOOKUP_FORM.MESSAGES.TITLE;
  info :string = ""; 
  isGenFlow: boolean = false;

  lastName = FLIGHT_LOOKUP_FORM.CONTROLS.LAST_NAME;
  pnr = FLIGHT_LOOKUP_FORM.CONTROLS.CONFIRMATION_NUMBER;
  ispnrInputFocused: boolean = false;
  isLastNameInputFocused: boolean = false;

  paymentMessage = PAYMENT_NOTIFICATION_MESSAGE;
  linkText :string = "";

  isTooltipDisplayed: boolean = false;
  showBoardingPassScan = false;
  showErrorMessage: boolean = false;
  errorMessage: string = "";


  flightLookupForm = new FormGroup({
    pnr: new FormControl("", this.pnr.validators),
    lastName: new FormControl("", this.lastName.validators),
  });

  limitChars = (maxLength: number, event: any) => {
    if (this.rtcService.isMobileDevice()
      && this.rtcService.getOSName() == supportedOS.android
      && event.target.value.toString().length >= maxLength) {
      this.pnrControl.patchValue(event.target?.value.substring(0, maxLength));
    }
  }

  isLoading: any = true;
  isLocationAvailable: boolean = false;
  pageConstants: ObjectLiteral;
  commonConstants: ObjectLiteral;
  languageSubscription: Subscription;
  confirmationNumberPlaceHolder: any;
  lastNamePlaceHolder: any;
  toAcceptFailedSearch: number = 0;

  flightLookupFormSubscription: Subscription;
  subscribeFlightLookupForm() {
    this.flightLookupFormSubscription = this.welcomeService.flightLookupFormSubject.subscribe((stream:{action:string, data:any}) => {
      if (stream.action === 'patchValue') this.flightLookupForm.patchValue(stream.data);
    })
  }

  pnrControlSubscription: Subscription;
  subscribePnrControl() {
    this.pnrControlSubscription = this.welcomeService.pnrControlSubject.subscribe((stream:{action:string, data:any}) => {
      if (stream.action === 'patchValue') this.pnrControl.patchValue(stream.data);
      if (stream.action === 'reset') this.pnrControl.reset();
    })
  }


  @ViewChild('errorModalBtn', { static: true }) errorModalBtn: ElementRef;

  constructor(
    @Inject(CONFIG) private config: Config,
    @Inject(DOCUMENT) private document: Document,
    @Inject(SESSION_STORAGE_SERVICE) private storage: StorageService,
    private logger: LoggerService,
    private sessionService: SessionService,
    private flightService: FlightService,
    private loadingService: LoadingService,
    private rtcService: RtcService,
    private router: Router,
    private sessionUtility: SessionUtilityService,
    private languageService: LanguageService,
    private helpOptionsService: HelpOptionsService,
    private welcomeService: WelcomeService,
  ) {
    this.languageSubscription = this.languageService.languageChanges.subscribe(() => {
      this.pageConstants = this.languageService.constants?.home || {};
      this.commonConstants = this.languageService.constants?.commons || {};
      this.confirmationNumberPlaceHolder = this.languageService.constants?.home.confirmationNumberPlaceHolder || '';
      this.lastNamePlaceHolder = this.languageService.constants?.home.lastNamePlaceHolder || '';
      this.logger.debug('FlightLookupFormComponent.constructor', this);
    })
  }

  async ngOnInit(): Promise<void> {
    if (this.sessionService.locationData.reason) { await this.helpOptionsService.getHelpOptions() };
    if (this.config?.MAINTENANCE_MODE === true) {
      if (!this.sessionService.locationData['airport-code'].length) {
        let params = this.storage.has(STORAGE_KEYS.PARAMS) ? this.storage.get(STORAGE_KEYS.PARAMS) : {};
        params[PARAMS.AIRPORT] = ENVIRONMENT.PROPERTIES.DEPARTMENTS.XYZ.NAME
        this.sessionService.setAirportCode(ENVIRONMENT.PROPERTIES.DEPARTMENTS.XYZ.NAME)
        this.storage.set(STORAGE_KEYS.PARAMS, params);
      }
      this.logger.info("MAINTENANCE_MODE", this.config)
      this.redirectPage(true, true);
      return;
    }

    this.isLocationAvailable = this.sessionService.isLocationAvailableInParams;
    this.isLocationAvailable = this.isLocationAvailable && !this.sessionUtility.isBoardingPassFlow();
    this.listenToLoading();
    await this.checkDeviceRtc()
    if(this.sessionService.locationData["routing-code"] == ROUTING_CODES.DOC.CODE) {
      this.info = FLIGHT_LOOKUP_FORM.MESSAGES.INFO_NO_SCAN;
      this.linkText = FLIGHT_LOOKUP_FORM.MESSAGES.LINK_TEXT;
    }
    this.setPnrFromParams();
    if (this.flightService.showBoardingPass) {
      this.onFormSubmit();
    } else {
      if (this.sessionService.easySearchData.lastName) {
        this.flightLookupForm.patchValue(this.sessionService.easySearchData);
      }
    }

    this.subscribeFlightLookupForm();
    this.subscribePnrControl();
  }

  async checkDeviceRtc() {
    const isCameraAvailable = await this.rtcService.isCameraAvailable();
    const isMobileDevice = await this.rtcService.isMobileDevice();
    this.showBoardingPassScan = isCameraAvailable && isMobileDevice

    this.linkText = this.showBoardingPassScan ? FLIGHT_LOOKUP_FORM.MESSAGES.SCAN_LINK_TEXT : FLIGHT_LOOKUP_FORM.MESSAGES.LINK_TEXT;
    this.info =
      this.showBoardingPassScan
        ? FLIGHT_LOOKUP_FORM.MESSAGES.INFO
        : FLIGHT_LOOKUP_FORM.MESSAGES.INFO_NO_SCAN;
  }

  pnrOnKeyup(event:any) {
    this.pnrControl?.patchValue(event.target.value.toUpperCase());
  }

  /**
   * If PNR and lastName are available in params update that to the form and validate
   */
  setPnrFromParams() {
    const {pnr_no,last_name} = this.sessionService.pnrDetails;
    if(pnr_no && pnr_no != '') {
      this.pnrControl.setValue(pnr_no.toUpperCase());
      this.pnrControl.markAsDirty();
    }
    if(last_name && last_name != '') {
      this.lastNameControl.setValue(last_name);
      this.lastNameControl.markAsDirty();
    }
    if (this.flightLookupForm.valid && this.sessionService.shouldSubmitPNR) {
      this.onFormSubmit();
    }
  }

  /**
   * Listen to the loadingSub property in the LoadingService class. This drives the
   * display of the loading spinner.
   */
  listenToLoading(): void {
    this.loadingService.loadingSub
      .pipe(delay(0))
      .subscribe(({ loading }) => {
        this.isLoading = loading;
      });
  }

  get lastNameControl(): FormControl {
    return this.flightLookupForm.get("lastName") as FormControl;
  }

  get pnrControl(): FormControl {
    return this.flightLookupForm.get("pnr") as FormControl;
  }

  async onFormSubmit() {
    try {
      this.errorMessageEmitter.emit('');
      const { pnr, lastName } = this.flightLookupForm.value;
      this.sessionService.easySearchData.lastName = lastName; 
      await this.flightService.getFlightDetails(pnr, lastName, this.sessionService.locationData.stationId);
      this.assignPnrDetailsInService(pnr,lastName) 
      if(this.flightService.activeTraveler == null){
        this.flightService.isHelpRequested = true;
        this.router.navigate(["/select-traveler"], {replaceUrl: true});
      }  
      else {
        this.sessionService.setIsCheckedIn(this.flightService.activeTraveler?.isCheckedIn);
        this.redirectPage();
      }
    
    } catch (e) {
      this.sessionService.isEncryptedStringInParams=false;
      this.sessionService.removePnrDetails();
      this.pnrControl.reset();
      this.navigateToPreChat();
      this.errorMessage = FLIGHT_LOOKUP_FORM.MESSAGES.ERROR;
      this.showErrorMessage = true;
      this.errorMessageEmitter.emit(this.errorMessage);
      this.logger.error("FlightLookupFormComponent: onFormSubmit()", e);
      this.document.defaultView.scrollTo(0, 0)
      this.sessionService.removePnrDetails();
    }
  }

  /**
   * Set the latest valid Pnr and lname to service and session
   */
  assignPnrDetailsInService(pnr: string, lastName: string): void {

    this.sessionService.pnrDetails = { pnr_no: pnr, last_name: lastName };
    this.sessionService.shouldSubmitPNR = false;
    this.sessionService.storePnrDetails();
  }

  async redirectPage(event = false, link = false): Promise<void> {
    event && this.sessionService.removePnrDetails();
    this.flightService.isHelpRequested = true;
    this.sessionService.isEasyPnrSearch = false;
    if (this.sessionUtility.isReasonParamValid(this.sessionService.locationData.reason)) {
      if (this.flightService.isIrropRoute()) {
        this.sessionUtility.configureSessionData();
        this.router.navigate([ROUTING_CODES.SELF_SERVICE.ROUTE], { replaceUrl: true });    
      } else {
        await this.helpOptionsService.getHelpOptions();
        this.sessionUtility.configureSessionData();
        this.router.navigate([ROUTING_CODES.PRE_CHAT.ROUTE], { replaceUrl: true });    
      }
    } else {
      if (link) {
        await this.navigateToPreChat();
      } else {
        if (this.sessionService.isEncryptedStringInParams) {
          this.navigateToPreChat()
        } else{
          await this.helpOptionsService.getHelpOptions();
          this.router.navigate([ROUTING_CODES.HELP_OPTIONS.ROUTE], { replaceUrl: true });
        }
      }
    }
  }

  async navigateToPreChat() {
    let isPreChat = true;
    this.flightService.isHelpRequested = true;
    this.sessionService.isEasyPnrSearch = false;
    this.sessionUtility.configureSessionData();
    await this.helpOptionsService.getHelpOptions(isPreChat);
    this.router.navigate([ROUTING_CODES.PRE_CHAT.ROUTE], { replaceUrl: true });
  }

  showTooltip(event: Event): void{
    event?.stopImmediatePropagation();
    this.isTooltipDisplayed = !this.isTooltipDisplayed;
  }
  

  ngOnDestroy() {
    this.languageSubscription && this.languageSubscription.unsubscribe();
  }
}
